import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'parentSection',
    'countElement',
    'countDisplay',
    'wrapperElement',
    'emptyStateMessage',
  ];

  connect() {
    const observer = new MutationObserver(() => {
      this.updateCount();
    });

    observer.observe(this.parentSectionTarget, {
      childList: true,
      tree: true,
    });
  }

  updateCount() {
    this.countDisplayTarget.textContent = this.countElementTargets.length;

    if (this.hasWrapperElementTarget) {
      if (this.countElementTargets.length === 0) {
        this.wrapperElementTarget.classList.add('d-none');
      } else {
        this.wrapperElementTarget.classList.remove('d-none');
      }
    }

    if (this.hasEmptyStateMessageTarget) {
      if (this.countElementTargets.length === 0) {
        this.emptyStateMessageTarget.classList.remove('d-none');
      } else {
        this.emptyStateMessageTarget.classList.add('d-none');
      }
    }
  }
}
